import React from "react";
import resumepdf from "../assets/SubhadipDas_Resume.pdf";
import resume from "../assets/resume.png";

function ViewResume() {
  return (
    <div>
      <div className="overflow-x-hidden">
        <embed
          src={resumepdf}
          className="hidden sm:block w-screen h-screen"
        />
        <img src={resume} alt="Subhadip Das resume preview" className="sm:hidden w-full" loading="lazy" decoding="async" />
      </div>
    </div>
  );
}

export default ViewResume;
